import axios from 'axios'

const apiClient = axios.create({
	baseURL: '/api/integration'
})

export default apiClient
